import type { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
};
const Rank: FC<Props> = (props) => {
  const { children } = props;

  return (
    <div className="rank">
      <h6>{children}</h6>
    </div>
  );
};

export default Rank;
